import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import homeConfig from "src/resources/homePage.json";
import { Accordion, AccordionTab } from "primereact/accordion";
import useResize from "src/hooks/useResize";
const FAQs = () => {
  const numberOfQuestions = homeConfig.faqs.numberOfQuestions;
  const { t } = useTranslation(["homePage", "common"]);
  const { isMobile } = useResize();
  const [showMore, setShowMore] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | number[]>();

  function closeOpenedQuestion() {
    setActiveIndex(-1);
  }

  React.useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (!(e.target as Element)?.closest("#faq-header")) {
        closeOpenedQuestion();
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  return (
    <section
      className="home-section how-to-register faqs w-100 container-fluid"
      id="faqs"
    >
      <div className="main-benefit">
        <h1 className="title text-center w-100">{t(`homePage.faqs.title`)}</h1>
        <div className="items">
          <Accordion
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            // onMouseLeave={closeOpenedQuestion}
          >
            {Array.from({ length: numberOfQuestions }).map(
              (_, index) =>
                (index < 5 || showMore || !isMobile) && (
                  <AccordionTab
                    key={index}
                    header={
                      <div
                        className={`d-flex d-flex align-items-center justify-content-start gap-2 `}
                        // onMouseLeave={closeOpenedQuestion}
                        id="faq-header"
                      >
                        <div
                          className={`${
                            activeIndex === index
                              ? "question-container-open active"
                              : ""
                          }`}
                        >
                          <div
                            className={`d-flex align-items-start justify-content-start gap-2 question ${
                              activeIndex === index
                                ? "open-question"
                                : "closed-question"
                            }`}
                          >
                            <span className="header-icon d-flex align-items-center justify-content-center">
                              {activeIndex !== index ? "+" : "-"}
                            </span>
                            <span className="question-text">
                              {t("questionLabel")}
                              {index + 1}:{" "}
                              {t(
                                `homePage.faqs.questions.q${index + 1}.question`
                              )}
                            </span>
                          </div>
                          {activeIndex === index && (
                            <Trans>
                              <div
                                className={`question-answer mt-2 d-flex align-items-start ${
                                  activeIndex === index ? "active" : ""
                                }`}
                              >
                                <span className="mx-1">
                                  {t("answerLabel")}:
                                </span>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: t(
                                      `homePage.faqs.questions.q${
                                        index + 1
                                      }.answer`
                                    ),
                                  }}
                                />
                              </div>
                            </Trans>
                          )}
                        </div>
                      </div>
                    }
                  ></AccordionTab>
                )
            )}
          </Accordion>
        </div>
        {isMobile && (
          <div
            className="show-more-text mt-2 mb-3"
            onClick={() => setShowMore(!showMore)}
          >
            <span>{showMore ? "-" : "+"}</span>
            <span>{showMore ? t("less") : t("more")}</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQs;
